import { css } from '@mui/material/styles';
export const formLabelComponentOverrides = {
    MuiFormLabel: {
        styleOverrides: {
            root: ({ theme }) => css `
                color: ${theme.palette.grey[900]};
                margin-bottom: ${theme.spacing(1)};
                font-weight: ${theme.typography.button.fontWeight};
                font-size: ${theme.typography.button.fontSize};

                &.Mui-focused {
                    color: ${theme.palette.text.primary};
                }

                & + .MuiInputBase-root {
                    margin-top: 0;
                }

                & .Mui-disabled {
                    color: ${theme.tokens.FuelColorTextTertiary};
                    opacity: 0.4;
                }

                & span.MuiFormLabel-asterisk.MuiInputLabel-asterisk {
                    font-size: ${theme.tokens.FuelFontSizeHeading5};
                    font-weight: ${theme.tokens.FuelFontWeightSemibold};
                    color: ${theme.tokens.FuelColorAlertErrorIcon};
                }

                &.Mui-error {
                    color: ${theme.palette.grey[900]};
                }
            `
        }
    }
};
